var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-info"},[_c('profile-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }